import { CommonModule, Location } from '@angular/common';
import { BrisbaneDatePipe } from '../../shared/pipes/brisbane-date.pipe';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ConsentFormComponent } from '../../shared/components/consent-form/consent-form.component';
import { CustomToastComponent } from '../../shared/components/toast/custom-toast.component';
import { HttpService } from '../../shared/services/http.service';


interface APIResponse {
    status: boolean;
    message: string;
    data: {
        mediaConsentToken: string;
        token: string;
        isMediaConsentParentApprovalRequired: any;
        eventId: string;
        eventName: string;
        eventTypeId: string;
        eventType: string;
        eventTypeDescription: string | null;
        description: string | null;
        eventStartDate: string;
        eventEndDate: string;
        eventTime: string;
        location: string;
        imagePaths: string[];
        audienceType: string;
        statusName: string;
        isRegistered: boolean;
        mediaConsentStatus: string;
        eventStatus: string;
        studentAge: string;
        registrationStatus: string;
        employerName: string;
        pointValue: number;

    };
}

@Component({
    selector: 'app-student-eventDetails',
    standalone: true,
    imports: [CommonModule, ConsentFormComponent, BrisbaneDatePipe],
    templateUrl: './students-eventDetails.component.html',
    styleUrls: ['./students-eventDetails.component.scss']
})
export class StudentEventDetailsComponent implements OnInit {
    eventId: string = '';
    eventSource: string = '';
    showEventModal: any = '';
    eventData: APIResponse['data'] | null = null;
    isLoading: boolean = true;
    downloading: boolean = false;
    isShowMediaConsent: boolean = false
    mediaToken: string = ''
    isRegistered: boolean = false;
    showConsentButton: boolean = false;
    isSubmitting: boolean = false;




    constructor(
        private dialog: MatDialog,
        private location: Location,
        public router: Router,
        private httpService: HttpService,
        private snackBar: MatSnackBar,
        private activatedRoute: ActivatedRoute
    ) { }

    ngOnInit(): void {
        this.getEventIdFromUrl();
    }

    private getEventIdFromUrl(): void {
        this.activatedRoute.params.subscribe(params => {
            this.eventId = params['id'];
            this.fetchEventDetails();
        });

        this.activatedRoute.queryParams.subscribe(queryParams => {
            this.eventSource = queryParams['source'] || 'student-event';
        });
    }

    isEventCancelled(): boolean {
        const s = String(this.eventData?.eventStatus ?? '').trim().toLowerCase();
        return s === 'cancelled' || s === 'event cancelled' || s === 'on hold' || s === 'onhold';
    }

    getStatusClass(status: any): string {
        if (!status) return '';
        const normalizedStatus = String(status).trim().toLowerCase();
        switch (normalizedStatus) {
            case 'ongoing':
            case 'on today':
                return 'active-text';
            case 'upcoming':
                return 'status-upcoming';
            case 'already held':
            case 'alreadyheld':
            case 'completed':
            case 'event completed':
                return 'completed-text';
            case 'onhold':
            case 'on hold':
            case 'cancelled':
            case 'event cancelled':
                return 'cancelled-text';
            default:
                return '';
        }
    }



    private fetchEventDetails(): void {
        if (this.eventId) {
            this.isLoading = true;
            this.httpService.get<APIResponse>(`studentdashboard/${this.eventId}`).subscribe({
                next: response => {
                    if (response?.status) {
                        // console.log(response.data.registrationStatus);
                        this.eventData = response.data;
                        this.isRegistered = this.eventData?.isRegistered;
                        this.showConsentButton = this.eventData?.isMediaConsentParentApprovalRequired && Number(this.eventData?.studentAge) < 16;
                    } else {
                        this.showErrorToast(response.message);
                    }
                    this.isLoading = false;
                },
                error: (error) => {
                    this.showErrorToast(error?.message);
                    this.isLoading = false;
                },
            });
        }
    }

    goBack() {
        if (this.isShowMediaConsent) {
            this.isShowMediaConsent = false
        } else {
            this.location.back();
        }
    }

    isFutureDate(dateStr: string): boolean {
        const date = new Date(dateStr);
        const today = new Date();

        date.setHours(0, 0, 0, 0);
        today.setHours(0, 0, 0, 0);

        return date > today;
    }

    onMediaConsent(event: any): void {
        let token = this.eventData?.mediaConsentToken
        this.isShowMediaConsent = true
        this.mediaToken = token ?? ''
        this.fetchEventDetails()
    }

    isPdf() {
        if (!this.eventData?.imagePaths[0]) return false
        return this.eventData?.imagePaths[0].toLowerCase().endsWith('.pdf');
    }

    async downloadFiles() {
        if (!this.eventData?.imagePaths?.length) return;

        let url = this.eventData?.imagePaths[0]
        if (this.isPdf()) {
            const link = document.createElement('a');
            link.href = url;
            link.target = '_blank';
            link.download = `student-evidence-document`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } else {
            this.showEventModal = url
        }

        // this.downloading = true

        // const zip = new JSZip();

        // const downloadTasks = this.eventData?.imagePaths.map(async (url, index) => {
        //     const response = await fetch(url);
        //     const blob = await response.blob();

        //     // Detect file extension
        //     let extension = 'file';
        //     const contentType = blob.type;

        //     if (contentType.includes('pdf')) {
        //         extension = 'pdf';
        //     } else if (contentType.includes('jpeg')) {
        //         extension = 'jpg';
        //     } else if (contentType.includes('png')) {
        //         extension = 'png';
        //     } else if (contentType.includes('webp')) {
        //         extension = 'webp';
        //     }

        //     zip.file(`document-${index + 1}.${extension}`, blob);
        // });

        // try {
        //     await Promise.all(downloadTasks);

        //     const zipBlob = await zip.generateAsync({ type: 'blob' });

        //     const link = document.createElement('a');
        //     link.href = URL.createObjectURL(zipBlob);
        //     link.download = 'event-files.zip';
        //     link.click();

        //     URL.revokeObjectURL(link.href);
        // } catch (error : any) {
        //     this.showErrorToast(error.message || "Something went wrong")
        // }

        // this.downloading = false
    }


    onRegister(event: any): void {
        event.preventDefault();

        if (this.isSubmitting) {
            return;
        }
        this.isSubmitting = true;
        if (this.eventId) {
            this.httpService.post<APIResponse>(`studenteventregistrations/register/${this.eventId}`, {}).subscribe({
                next: response => {
                    // console.log(response);
                    if (response?.status) {
                        this.isSubmitting = false;
                        this.fetchEventDetails()
                        this.showSuccessToast(response.message);
                        if (!response?.data?.isMediaConsentParentApprovalRequired && this.eventSource == 'csqEvents') {
                            this.isShowMediaConsent = true;
                            this.mediaToken = response?.data?.mediaConsentToken
                        } else {
                            this.isShowMediaConsent = false
                            this.isSubmitting = false;
                        }
                        // this.isRegistered = true;
                    } else {
                        this.showErrorToast(response.message);
                        this.isSubmitting = false;
                    }
                },
                error: (error) => {
                    this.showErrorToast(error?.message);
                    this.isSubmitting = false;
                },
            });
        } else {
            this.showErrorToast('Event ID not found');
            this.isSubmitting = false;
        }
    }

    onConsentSubmitted(): void {
        this.isShowMediaConsent = false;
        this.fetchEventDetails();
    }
    // onCancelRegister(): void {
    //     const dialogData: AlertDialogData = {
    //         title: 'Unregister from event?',
    //         message: "Are you sure you want to continue?",
    //         okText: 'Unregister',
    //         cancelText: 'Cancel',
    //         icon: 'warning',
    //         submessage: "",
    //         cancelButtonColor: '#007BFF',
    //         okButtonColor: '#EF4A00 ',
    //     };

    //     const dialogRef = this.dialog.open(AlertDialogComponent, {
    //         width: '25.438rem',
    //         data: dialogData,
    //     });

    //     dialogRef.afterClosed().subscribe(result => {
    //         if (result) { 
    //             if (this.eventId) { 
    //                 this.httpService.post<APIResponse>(`StudentEventRegistrations/unregister/${this.eventId}`, {}).subscribe({
    //                     next: response => {
    //                         if (response?.status) {
    //                             this.fetchEventDetails()
    //                             this.showSuccessToast(response.message); 
    //                         } else {
    //                             this.showErrorToast(response.message);
    //                         }
    //                     },
    //                     error: (error) => {
    //                         this.showErrorToast(error?.message);
    //                     },
    //                 });
    //             } else {
    //                 this.showErrorToast('Event ID not found');
    //             } 
    //         }
    //     });
    // } 


    onCancelRegister(): void {
        if (this.eventId) {
            this.httpService.post<APIResponse>(`StudentEventRegistrations/unregister/${this.eventId}`, {}).subscribe({
                next: response => {
                    if (response?.status) {
                        this.fetchEventDetails()
                        this.showSuccessToast(response.message);
                    } else {
                        this.showErrorToast(response.message);
                    }
                },
                error: (error) => {
                    this.showErrorToast(error?.message);
                },
            });
        } else {
            this.showErrorToast('Event ID not found');
        }
    }


    getLabelByStatus(): string {
        const map: Record<string, string> = {
            NotRegistered: 'register',
            // UnregisteredAddedManually: 'register',
            // NewNonOnboarded: 'register',
            Unregistered: 'register',
            TeacherReviewPending: 'TeacherReviewPending',
            Interested: 'unregister',
            TeacherApproved: 'unregister',
            AdminApproved: 'unregister',
            UnregisteredAddedManually: 'unregister',
            Registered: 'unregister',
            NewNonOnboarded: 'unregister',
            TeacherRejected: 'rejected',
            AdminRejected: 'rejected'
        };

        const status = this.eventData?.registrationStatus ?? 'NotRegistered';

        return map[status] ?? 'register';
        // return  'register'; 
    }

    formatDate(dateString: string): string {
        return new Date(dateString).toLocaleDateString('en-US', {
            year: 'numeric',
            month: 'long',
            day: 'numeric'
        });
    }

    closeEventModal() {
        this.showEventModal = false;
    }

    getEventImage(): boolean {
        if (this.eventData?.imagePaths && this.eventData.imagePaths.length > 0) {
            return true
            // this.eventData.imagePaths[0];
        }
        return false;
    }

    private showSuccessToast(message: string): void {
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'success-toast']
        });
    }

    private showErrorToast(message: string | null | undefined): void {
        if (!message) return;
        this.snackBar.openFromComponent(CustomToastComponent, {
            data: { message },
            duration: 3000,
            horizontalPosition: 'right',
            verticalPosition: 'top',
            panelClass: ['no-padding-snackbar', 'error-toast']
        });
    }
}
